module.exports = __webpack_public_path__ + "img/DNK.03098513.svg";